<!--suppress ES6ModulesDependencies -->
<template>
    <div>
        <Resumo v-if="m_tela === RESUMO" :value="value" @input="$listeners.input" @nextPage="irParaDadosBancarios()" @prevPage="$listeners.prevPage" @finalizado="$listeners.finalizado" />
        <DadosBancarios v-if="m_tela === SELECIONAR_CONFIRMACAO" :value="value" @input="$listeners.input" @nextPage="$listeners.nextPage" @prevPage="irParaResumo()" />
    </div>
</template>

<script>
  import DadosBancarios from './DadosBancarios'
  import Resumo from './Resumo'

  export default {
    name: 'Confirmacao',
    components: { DadosBancarios, Resumo },
    props: { value: Object, tela: { type: String, validators: ['selecionar_prazo_parcela', 'selecionar_grupo', 'resumo'] } },
    data: () => ({
      m_tela: ''
    }),
    computed: {
      SELECIONAR_CONFIRMACAO: () => 'selecionar_prazo_parcela',
      RESUMO: () => 'resumo'
    },
    watch: {
      tela (val) {
        this.m_tela = val
      }
    },
    mounted () {
      this.m_tela = this.tela || this.RESUMO
    },
    methods: {
      reload (reload) {
        this.$emit('reload', reload)
      },
      irParaDadosBancarios () {
        this.m_tela = this.SELECIONAR_CONFIRMACAO
      },
      irParaResumo () {
        this.m_tela = this.RESUMO
      }
    }
  }
</script>

<style scoped>
</style>
